import { IXC_FUNDING_V1_TRANSFER_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-funding-v1-transfer-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcFundingV1TransferStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface FundingTransferStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcFundingV1TransferStatus | undefined;
}

export function FundingTransferStatusPill({ isPending, status, ...props }: FundingTransferStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_FUNDING_V1_TRANSFER_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcFundingV1', enumName: 'IxcFundingV1TransferStatus', value: status }} />
    </Pill>
  );
}
